import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ManualUpdateRequest } from "../student-pay-fine/ManualUpdateRequest";
import { StudentFineInsertRequest } from "./StudentFineInsertRequest";
import { AutomaticallyPayFineRequest } from "./AutomaticallyPayFineRequest";
import { AutomaticallyWaiveFineRequest } from "./AutomaticallyWaiveFineRequest";
import { AccountCreditRefundRequest } from "./AccountCreditRefundRequest";
import { AccountCreditAdjustRequest } from "./AccountCreditAdjustRequest";
import { AccountDebitAdjustRequest } from "./AccountDebitAdjustRequest";

@Injectable()
export class DataService_StudentFinesDebts {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadFine(PersonID, NotPaidOnly, OrderAsc, SchoolID) {
		var postResult$ = new Subject();
		var url = "Fine/LoadFine?PersonID=" + PersonID + "&NotPaidOnly=" + NotPaidOnly + "&OrderAsc=" + OrderAsc + "&SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadFineTypes(SchoolID) {
		var postResult$ = new Subject();
		var url = "Fine/LoadFineTypes?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadCurrentBalance(PersonID) {
		var postResult$ = new Subject();
		var url = "Fine/LoadCurrentBalance?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentFineInsert(parms: StudentFineInsertRequest) {
		var postResult$ = new Subject();
		var url = "Fine/StudentFineInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TenderTypeGetList() {
		var postResult$ = new Subject();
		var url = "Fine/TenderTypeGetList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutomaticallyPayFine(parms: AutomaticallyPayFineRequest) {
		var postResult$ = new Subject();
		var url = "Fine/AutomaticallyPayFine";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AutomaticallyWaiveFine(parms: AutomaticallyWaiveFineRequest) {
		var postResult$ = new Subject();
		var url = "Fine/AutomaticallyWaiveFine";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ManuallyPayWaive(parms: ManualUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Fine/ManuallyPayWaive ";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadFineDetails(PersonID, AccountDebitID, AccountCreditID) {
		var postResult$ = new Subject();
		var url = "Fine/LoadFineDetails?PersonID=" + PersonID + "&AccountDebitID=" + AccountDebitID + "&AccountCreditID=" + AccountCreditID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AccountCreditRefund(parms: AccountCreditRefundRequest) {
		var postResult$ = new Subject();
		var url = "Fine/AccountCreditRefund";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AccountCreditAdjust(parms: AccountCreditAdjustRequest) {
		var postResult$ = new Subject();
		var url = "Fine/AccountCreditAdjust";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AccountDebitAdjust(parms: AccountDebitAdjustRequest) {
		var postResult$ = new Subject();
		var url = "Fine/AccountDebitAdjust";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
